export enum PaymentMethods {
  /**
   * Предоплата
   */
  PREPAYMENT = 'prepayment',

  /**
   * Отсрочка платежа
   */
  DEFERMENT = 'deferment_payment',

  /**
   * Отсрочка платежа и предоплата одновременно
   */
  DEFERMENT_PREPAYMENT = 'deferment_payment_prepayment',
}

export const PaymentMethodsTranslate: Record<string, string> = {
  [PaymentMethods.PREPAYMENT]: 'Предоплата',
  [PaymentMethods.DEFERMENT]: 'Постоплата',
  [PaymentMethods.DEFERMENT_PREPAYMENT]: 'Постоплата/Предоплата',
};
